import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: auto;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  height: auto;
  & > bds-tooltip {
    margin-left: 10px;
    margin-top: 6px;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  & > bds-typo:first-of-type {
    margin-top: 0rem;
  }
`;

export const ModalOverlay = styled.div<{ $positionY: number }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); 
  z-index: 1000; 
`;

export const ModalContainer = styled.div<{ $positionY: number }>`
  background-color: white;
  border-radius: 8px;
  padding: 30px;
  max-width: 700px;
  max-height: 600px;
  width: 90%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  position: absolute;
  top: ${({ $positionY }) => $positionY + (-80)}px;
  left: 50%;
  transform: translateX(-50%);
  overflow-y: auto;
`;

export const ModalOpenButton = styled.div`
  cursor: pointer;
  text-decoration: underline;
  display: inline-flex;
  align-items: center;
  color: #0096fa;
`;

export const HeaderLink = styled(RouterLink)`
  text-decoration: none;
`;

export const ModalCloseButtonArea = styled.div`
   width: 100%;
   display: flex;
   justify-content: space-between;
   gap: 1em;
   padding-bottom: 24px;
`;

export const ModalItemBg = styled.div`
  background-color: #f5f5f5;
  padding: 15px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  margin-top: 10px;
`;

export const ModalCloseButton = styled.div`
  cursor: pointer;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
`;
